import { useSelector } from 'react-redux'

import { selectLanguage } from 'root-redux/selects/common'

import { Language } from 'root-constants'

export const useActiveLanguage = () => {
  const language = useSelector(selectLanguage)

  const isEnLanguage = language === Language.EN
  const isEsLanguage = language === Language.ES
  const isFrLanguage = language === Language.FR
  const isDeLanguage = language === Language.DE
  const isArLanguage = language === Language.AR
  const isTrLanguage = language === Language.TR
  const isIdLanguage = language === Language.ID

  return {
    isEnLanguage,
    isEsLanguage,
    isFrLanguage,
    isDeLanguage,
    isArLanguage,
    isTrLanguage,
    isIdLanguage,
  }
}
